import React, { Component } from 'react';
import openSocket from 'socket.io-client';

import './Table.css';
import Actions from './Actions';
import Seat from './Seat';
import tableBackground from './img/table.png';

let tableStyle = {
  backgroundImage: `url(${tableBackground})`,
  backgroundPosition: '50% 50%',
};

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hand: null,
      seats: [],
      isLoaded: false,
      hideCards: false,
      msg: '',
      q: [],
      isProcessing: false,
      isLoggedIn: false,
      userIsSeated: false,
      userIsActing: false,
      waitingForResolution: false,
      actions: [],
    };

    this.socket = openSocket(process.env.REACT_APP_SERVER_URL);
    this.socket.on('connect', () => {
      this.socket.emit('VIEWING', {_id: this.props.id});

      this.socket.on('QUEUE', (evt) => {
        const newQ =  this.state.q.slice();
        newQ.push(evt);
        this.setState({q: newQ});
      });
    });
  }

  findSeat(number) {
    return this.state.seats.find(p => { return p.number === number; });
  }

  addPositions(seats) {
    let start = -1;
    for (let i = 0; i < seats.length; i++) {
      if (seats[i].currentPlayer) {
        start = seats[i].number;
      }
    }
    if (start === -1) {
      start = 1;
    }

    for (let i = 0; i < seats.length; i++) {
      if (seats[i].number < start) {
        seats[i].pos = seats[i].number - (start - 7);
      } else {
        seats[i].pos = seats[i].number - start + 1;
      }
    }
  }

  addAnimations(seats) {
    seats.forEach((seat) => {
      seat.animations = {};
    });
  }

  processQueue() {
    if (this.state.isProcessing || this.state.q.length === 0) {
      console.log('already processing Q');
      return;
    }
    const newQ = this.state.q.slice();
    console.log('newQ: ', newQ);
    const evt = newQ.shift();
    console.log('evt: ', evt);
    this.setState({isProcessing: true, q: newQ});
    if (evt.type === 'DEAL') {
      this.animateDeal(3, () => this.fetchTable());
    } else if (evt.type === 'ANTE') {
      this.animateAnte(evt.seats, () => this.fetchTable());
    } else if (evt.type === 'HAND_OVER') {
      this.animateWinner(evt, () => this.fetchTable());
    } else if (evt.type === 'ROUND_OVER') {
      this.animateRoundOver(evt, () => this.fetchTable());
    } else if (evt.type === 'PLAYER_ACTED') {
      window.setTimeout(() => {
        this.setState({isProcessing: false});
        if (!newQ[0] || (newQ[0] && newQ[0].type !== 'ROUND_OVER' &&
                         newQ[0].type !== 'HAND_OVER')) {
          this.fetchTable();
        }
      }, 1000);
    } else {
      this.fetchTable();
    }
  }

  animateWinner(evt, callback) {
    // TODO: animate paying the winner
    const winners = [];
    const newSeats = evt.table.seats;
    newSeats.forEach((seat) => {
      if (evt.winning_seat_numbers.includes(seat.number)) {
        winners.push(seat.player.name);
        if (evt.winning_hands) {
          seat.winner = evt.winning_hands.find((hand) => {
            return hand[1] === seat.number;
          });
          if (seat.winner) {
            seat.winner = seat.winner[0];
          }
        }
      }
    });
    const win_msg = (`${winners.join(' and ')} ` +
                     `win${winners.length > 1 ? '' : 's'} ${evt.payout}`);

    const idx = this.state.seats.findIndex((seat) => {
      return seat.currentPlayer;
    });
    evt.table.seats[idx].currentPlayer = true;

    this.addPositions(evt.table.seats);
    this.addAnimations(evt.table.seats);
    this.setState({
      userIsActing: false,
      msg: win_msg,
      isLoaded: true,
      seats: evt.table.seats,
      hand: evt.table.hand
    });

    window.setTimeout(() => {
      this.setState({isProcessing: false});
      callback();
    }, 5000);
  }

  animateRoundOver(evt, callback) {
    const newSeats = this.state.seats.slice();
    newSeats.forEach((seat) => {
      seat.bet = evt.complete_bets[seat.number];
    });
    this.setState({seats: newSeats});

    window.setTimeout(() => {
      const newSeats = this.state.seats.slice();
      newSeats.forEach((seat) => {
        if (seat.bet) {
          let bet = {};
          switch(seat.pos) {
            case 1:
              bet = {transform: 'translate(4.2vw, -6.5vw)'}; break;
            case 2:
              bet = {transform: 'translate(30vw, 4.5vw)'}; break;
            case 3:
              bet = {transform: 'translate(20vw, 13.5vw)'}; break;
            case 4:
              bet = {transform: 'translate(-5vw, 16.5vw)'}; break;
            case 5:
              bet = {transform: 'translate(-30vw, 13.5vw)'}; break;
            case 6:
              bet = {transform: 'translate(-27vw, -7.5vw)'}; break;
            default:
              break;
          }
          seat.animations.bet = bet;
        }
      });
      this.setState({seats: newSeats});

      window.setTimeout(() => {
        const finSeats = this.state.seats.slice();
        finSeats.forEach((seat) => {
          seat.animations.bet = null;
        });
        this.setState({seats: finSeats, isProcessing: false});
      }, 750);
    }, 0);
  }

  animateAnte(seats, callback) {
    const newSeats = this.state.seats.slice();
    newSeats.forEach((seat) => {
      if (seats.includes(seat.number)) {
        let coin = {};
        switch(seat.pos) {
          case 1:
            coin = {transform: 'translate(12.3vw, -19.2vw)'}; break;
          case 2:
            coin = {transform: 'translate(45.4vw, 1.8vw)'}; break;
          case 3:
            coin = {transform: 'translate(27.3vw, 26vw)'}; break;
          case 4:
            coin = {transform: 'translate(2.4vw, 26vw)'}; break;
          case 5:
            coin = {transform: 'translate(-22.6vw, 26.3vw)'}; break;
          case 6:
            coin = {transform: 'translate(-40.6vw, 1.8vw)'}; break;
          default:
            break;
        }
        seat.animations.coin = coin;
      }
    });
    const msg = (this.state.hand && this.state.hand.ante ?
                 `Ante: ${this.state.hand.ante}` : '');
    this.setState({seats: newSeats, hideCards: true, msg});
    window.setTimeout(() => {
      const finSeats = this.state.seats.slice();
      finSeats.forEach((seat) => {
        seat.animations.coin = null;
      });
      this.setState({
        seats: finSeats, isProcessing: false, hideCards: false, msg: ''});
      callback();
    }, 1000);
  }

  animateDeal(street, callback) {
    callback();
  }

  componentDidUpdate() {
    this.processQueue();
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_SERVER_URL}/check_login`, {
      credentials: 'include',
    })
      .then(
        (resp) => {
          if (resp.ok) {
            this.setState({isLoggedIn: true});
            return true;
          } else {
            this.props.history.replace('/');
            return false;
          }
        })
      .then((isLoggedIn) => {
        if (!isLoggedIn) {
          return;
        }

        this.fetchTable();
      });
  }

  act(action) {
    fetch(`${process.env.REACT_APP_SERVER_URL}/table/${this.props.id}/act`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({action}),
    })
      .then(res => res.json())
      .then((result) => {
        if (result.error) {
          this.setState({msg: result.error});
          return;
        }

        // TODO: Queue an animation of the action
        this.fetchTable();
      });
  }

  fetchActions() {
    fetch(`${process.env.REACT_APP_SERVER_URL}/table/${this.props.id}/actions`,
          { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({actions: result.actions});
        });
  }

  fetchTable() {
    if (this.state.isProcessing) {
      const newQ = this.state.q.slice();
      newQ.push({'type': 'FETCH_TABLE'});
      this.setState({q: newQ});
      return;
    }

    this.setState({isProcessing: true});

    fetch(`${process.env.REACT_APP_SERVER_URL}/table/${this.props.id}`, {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(
        (result) => {
          this.processTable(result);
        },
        (error) => {
          this.setState({
            isLoaded: true,
            msg: 'An error occurred',
          });
        }
      );
  }

  processTable(result) {
    if (result.seats) {
      const currentPlayer = result.seats.find((seat) => {
        return seat.currentPlayer;
      });
      if (currentPlayer) {
        this.setState({userIsSeated: true});
      }
      const currentPlayerIsActing = result.seats.find((seat) => {
        return seat.currentPlayer && seat.acting;
      });
      if (currentPlayerIsActing) {
        this.setState({userIsActing: true});
        this.fetchActions();
      } else {
        this.setState({userIsActing: false});
      }
      this.addPositions(result.seats);
      this.addAnimations(result.seats);
    }
    this.setState({
      isLoaded: true,
      seats: result.seats,
      hand: result.hand,
      isProcessing: false,
    });
  }

  onSit(seat_number) {
    this.socket.emit('SIT', {_id: this.props.id, seat_number});
    this.fetchTable();
  }

  render() {
    if (!this.state.isLoggedIn) {
      return (<div></div>);
    }

    const {error, isLoaded, msg} = this.state;
    if (error) {
      return (
        <div className="table" style={ tableStyle }>
          <div className="sys-msg">{ msg }</div>
        </div>
      );
    } else if (!isLoaded) {
      return  (
        <div className="table" style={ tableStyle }>
          <div className="sys-msg">Loading...</div>
        </div>
      );
    } else {
      const seats = [];
      for (let i=1; i<=6; i++) {
        const seat = this.findSeat(i);
        const key = seat ? seat.number : i;
        const pos = seat ? seat.pos : i;
        seats.push(
          <Seat userIsSeated={this.state.userIsSeated}
                seat={seat} key={key} pos={pos}
                hideCards={this.state.hideCards}
                onSit={this.onSit.bind(this)}/>
        );
      }

      let pot;
      if (this.state.hand && this.state.hand.pot && !this.state.hideCards) {
        pot = (
          <div className="pot">
            <div className="label">Pot:</div>
            <div className="coin"></div>
            <div className="amt">{this.state.hand.pot}</div>
          </div>
        );
      } else {
        pot = (
          <div className="pot"></div>
        );
      }

      const onFold = this.act.bind(this, 'FOLD');
      const onCheck = this.act.bind(this, 'CHECK');
      const onCall = this.act.bind(this, 'CALL');
      const onBet = this.act.bind(this, 'BET');
      const onBringIn = this.act.bind(this, 'BRING_IN');
      const onRaise = this.act.bind(this, 'RAISE');

      return (
        <div className="table" style={ tableStyle }>
          <div className="sys-msg">{ msg }</div>
          <Actions isActing={this.state.userIsActing}
                   actions={this.state.actions}
                   hide={this.state.hideCards}
                   onFold={onFold}
                   onCheck={onCheck}
                   onCall={onCall}
                   onBet={onBet}
                   onBringIn={onBringIn}
                   onRaise={onRaise}/>
          {pot}
          {seats}
        </div>
      );
    }
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/Table.js